
(function ($) {
  $(document).ready(function () {
    const label_coming_soon = "Coming soon";
    const label_sold_out = "Available Soon";
    const label_add_to_cart = "Add to cart";
    const label_pre_order = "Pre-order";

    showListProduct();

    function showListProduct() {
      if ($('.static-product-page').length > 0) {
        const staticPage = $('.static-product-page');
        const listCollectionProduct = staticPage.find('.collection');
        const loadingElm = staticPage.find('.loading');
        const contentPage = loadingElm.siblings('[data-content-page]');

        loadingElm.addClass('loader');
        contentPage.hide();

        listCollectionProduct.map(function (i, ele) {
          let collectionID = $(ele).data('collection');

          callAPIGetCollection(collectionID, ele)
            .then(function (result) {
              loadingElm.removeClass('loader');
              contentPage.show();
              showProduct(result, ele);
            })
            .catch((err) => {
              loadingElm.removeClass('loader');
              contentPage.show();
            });
        });
      };
    }

    function callAPIGetCollection(collectionID) {
      let promiseObj = new Promise(function (resolve, reject) {
        callAPIWithTokenRefresh(`collections/${collectionID}/products`, 'get')
          .then(function (res) {
            resolve(res);
          }).catch(function (res) {
            reject([]);
          });
      });

      return promiseObj;
    }

    function showProduct(data, ele) {
      console.log('data: ', data);

      if (data) {
        if (data.status) {
          let html_product = `
            <section class="section"><div class="container"><div class="list-products grid grid--large">
          `;

          for (let i = 0; i < data.data.length; i++) {
            let item = data.data[i];
            let variants = item.variants;

            var priceNot0 = variants.filter((variant) => {
              return variant.price > 0;
            });
        
            // if(!priceNot0.length) return;
        

            let variant = priceNot0[0];
            // let variant = variants[0];
            let discount_html = '', old_price = '';

            if(variant) {
              if (variant.compare_at_price) {
                let discount = (variant.compare_at_price - variant.price) / variant.compare_at_price * 100;
                discount = Math.round(discount);
                if (discount) {
                  discount_html = ` <div class="discount"><span>Discount</span><span>${discount}%</span></div>`;
                }
                old_price = Shopify.formatMoney(variant.compare_at_price * 100, window.myprice);
              }

              let image = item.image != undefined ? item.image.src : '';
  
              var _tag = item.tags, _res = _tag.split(","), list_label = "";

              let _model = '';
              // default is_out_of_stock is TRUE
              let is_out_of_stock = true;
              let is_coming_soon = false;
              let is_pre_order = false;
              for (_i = 0; _i < _res.length; _i++) {
                var _required = _res[_i].includes("__required");
  
                if (_required) {
                  var label_class = _res[_i].replace('__required:', '');
                  label_class = label_class.trim();
                  label_class = label_class.replace(new RegExp(' ', 'g'), '_') + "_label";
                  label_class = label_class.toLowerCase();
  
                  list_label += '<span class="label label--required ' + label_class + '">' + _res[_i].replace('__required:', '') + '</span>';
                };

                // Product model tag
                if (_res[_i].includes("__model")) {
                  _model = _res[_i].replace('__model:', '');
                };
  
                // Product label custom tag
                var _label = _res[_i].includes("__label");
  
                if (_label) {
                  var label_class = _res[_i].replace('__label:', '');
                  label_class = label_class.trim();
                  label_class = label_class.replace(new RegExp(' ', 'g'), '_') + "_label";
                  label_class = label_class.toLowerCase();
                  let label_name = _res[_i].replace('__label:', '');
                  let label_name_lower = label_name.trim().toLowerCase();
                  if (label_name_lower == "pre order" || label_name_lower == "đặt hàng trước" || label_name_lower == "combo mới") {
                    is_pre_order = true;
                    setTimeout(() => {
                      $(this).find('.product__add-to-cart').text(label_name);
                    }, 1000);
                  }
  
                  if (label_name_lower == "hàng sắp về" || label_name_lower == "coming soon") {
                    setTimeout(() => {
                      $(this).find('.product__add-to-cart').text(label_name).attr('disabled', 'disabled');
                    }, 1000);
                    label_name = label_coming_soon;
                    is_coming_soon = true;
                  }
  
                  list_label += '<span class="label label--custom ' + label_class + '">' + label_name + '</span><br/>';
                };  
              }
  
              let sold_out = false, variant_available = false, sold_out_1 = true, no_variant = false;
              let form_add_to_cart = `
                <form method="post" action="/cart/add" id="product_form_recent_${item.id}" accept-charset="UTF-8" class="product__form" enctype="multipart/form-data">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="quantity" value="1">
                  <input type="hidden" value="${sold_out}">
                `;

              if (variants) {
                form_add_to_cart += `
                  <input type="hidden" name="variant_available" value="${variant_available}">
                  <input type="hidden" name="no_variant" value="${no_variant}">
                  <input type="hidden" value="${sold_out_1}">
                `;

                let text_add_to_cart = label_add_to_cart;
                let is_disable_add_to_cart = '';

                variants.map(function (_variant) {
                  /* if any variant has stock, is_out_of_stock = FALSE, otherwise BREAK */
                  if (_variant.inventory_quantity !== 0)
                    is_out_of_stock = false;
                  
                  if (_variant.title != "Default Title" && variant_available == false && _variant.price != 0) {
                    form_add_to_cart += `
                      <input type="hidden" name="id" value="${_variant.id}">
                      <input type="hidden" name="single-price" data-price="${_variant.price}" value="${Shopify.formatMoney(_variant.price * 100, window.myprice)}">
                      <input type="hidden" name="single-compare-at-price" data-price="${_variant.compare_at_price}" value="${Shopify.formatMoney(_variant.compare_at_price, window.myprice)}">
                      <input type="hidden" name="variant_available" value="${variant_available = true}">
                      <input type="hidden" name="single-option-selector-0" value="${_variant.option1}">
                      <input type="hidden" name="single-option-selector-1" value="${_variant.option2}">
                      <input type="hidden" name="single-option-selector-2" value="${_variant.option3}">
                      <input type="hidden" value="${sold_out_1}">
                    `;
                  } else {
                    form_add_to_cart += `
                      <div class="price_variant" data-price="${_variant.price}">
                        <input class="pri" type="hidden" name="${_variant.price}" value="${Shopify.formatMoney(_variant.price * 100, window.myprice)}">
                    `;

                    if (_variant.compare_at_price > _variant.price) {
                      form_add_to_cart += `<input class="pri_c" type="hidden" name="${_variant.compare_at_price}" value="${Shopify.formatMoney(_variant.compare_at_price * 100, window.myprice)}">`;
                    }

                    form_add_to_cart += `</div>`;
                  }
  
                  if (_variant.title == "Default Title") {
                    no_variant = true;
                    form_add_to_cart += `<input type="hidden" name="no_variant" value="${no_variant}">
                                      <input type="hidden" name="id" value="${_variant.id}">`;
                  }
                  available = true;
                });

                if (is_out_of_stock) {
                  text_add_to_cart = label_sold_out;
                  is_disable_add_to_cart = 'disabled="disabled"';
                }

                if (is_pre_order) {
                  text_add_to_cart = label_pre_order;
                }

                if (is_coming_soon) {
                  text_add_to_cart = label_coming_soon;
                  is_disable_add_to_cart = 'disabled="disabled"';
                }

                form_add_to_cart += `<div class="product-item__add-to-cart button-wrapper"><a href="/products/${item.handle}" ${is_disable_add_to_cart} class="product__add-to-cart button button--primary button--orange">${text_add_to_cart}</a></div>`;
              }

              form_add_to_cart += `</form>`;
  
              html_product += `
                    <div class="grid__cell 1/2 1/3--lap-and-up 1/3--desk">
                      <div class="product-item product-item--push">
                        <figure class="product-item__image-container">
                          <div class="product-item__image-wrapper">
                            <a href="/products/${item.handle}"><div class="aspect-ratio"> <img class="product-item__image image--fade-in lazyloaded" alt="${item.product_type}" src="${image}"></div></a>
                          </div>
                          <div class="product-item__labels labels">${list_label}</div>
                          ${discount_html}
                        </figure>
                        <div class="product-item__info">
                          <span class="no-color-swatch"></span>
                          <h3 class="product-item__title">
                            <a href="/products/${item.handle}" tabindex="-1" aria-hidden="true" alt="${item.product_type}" class="link">${item.title}</a>
                          </h3>
                          <div class="model-product">${_model}</div>
                          <div class="product-content-bottom">
                            <span class="product-item__price product-item__price--new" data-money-convertible="">${Shopify.formatMoney(variant.price * 100, window.myprice)}</span>
                            <div class="tooltip-wrapper">
                              <span class="price-tooltip">1</span>
                              <div class="tooltip-content"><p>1. Prices indicated refer to Suggested Retail Price and may change from time to time without prior notice.</p></div>
                            </div>
                            <span class="product-item__price product-item__price--old" data-money-convertible="">${old_price}</span><br>
                            ${form_add_to_cart}
                          </div>
                        </div>
                        <div class="product-item__see-more button-wrapper ">
                          <a href="/products/${item.handle}" class="button button--primary">View Details</a>
                        </div>
                      </div>
                    </div>`;
            }
          }

          html_product += `</div></div><section`;

          $(ele).append(html_product);
        }
      }
    }
  })
}(jQuery));
